//cut off time 10pm

var cday;
var nday;

var timeInSecs;
var ticker;
var vday = 0;
var bday = 0;
function getSeconds() {
var now = new Date();
var nowtime= now.getTime();  // time now in milliseconds
var date1 = now.getDate();
var hour1 = now.getHours();

if(date1 == 6)
{
 date1=date1+3;
}
else if(date1== 0)
{
  date1=date1+3;
}
else
{
 date1=date1;
}
if (hour1>=21)
{
bday=now.getDay()+3;
}
else
{bday=now.getDay()+2;
}
if(bday==2)
{nday=3;}
else if(bday==6)
{nday=1;}
else if(bday==7)
{nday=2;}
else if(bday>=8)
{nday=3;}
else
{nday=bday;}


var countdowntime = new Date(now.getFullYear(),now.getMonth(),date1,22,0,0); //  22 hrs = 10 pm cut-off time for BDS and IPS
    
var atime = countdowntime.getTime();
var diff = parseInt((atime - nowtime)/1000);  // positive if date is in future




if (cday < 0) { cday += 1; }   // aleady passed countdown time, so go for next week
if (diff <= 0) { diff += (86400 * 1) }
startTimer (diff);
}

function startTimer(secs) {
timeInSecs = parseInt(secs);
ticker = setInterval("tick()",1000); 
tick(); // to start counter display right away
}


   
function tick() {
var secs = timeInSecs;
if (secs>0)   { 
timeInSecs--; 
} 
else { 
clearInterval(ticker); // stop counting at zero
getSeconds();  // and start all over again! 
 }
        
var weekdays = new Array(7);
weekdays[0] =  "Sunday";
weekdays[1] = "Monday";
weekdays[2] = "Tuesday";
weekdays[3] = "Wednesday";
weekdays[4] = "Thursday";
weekdays[5] = "Friday";
weekdays[6] = "Saturday";

var n1 = weekdays[nday]; 
var n2 = nday - cday;
var days = Math.floor(secs/86400);
secs %= 86400;
var hours= Math.floor(secs/3600);
secs %= 3600;
var mins = Math.floor(secs/60);
secs %= 60;
if(bday==8)
hours=hours+48;
else if(bday==9)
hours=hours+24;

else if(bday==2)
hours=hours+24;
if(hours == 23 && mins == 59 && secs ==59)
{ location.reload(); }


var result = hours ;
result +=  " hrs "+ ( (mins < 10) ? "0" : "" ) + mins
+ " mins " + ( (secs < 10) ? "0":"" ) + secs + " secs";
  
$("#countdown1").html("Want the product by "+  n1.fontcolor("#1f461c") +","+ " order within "+result.fontcolor("#1f461c")+" with"+ " "+ "PRIORITY SHIPMENT");
}

$.getJSON('https://api.ipgeolocation.io/ipgeo?apiKey=8ad5bce8eaa84f95885778d7ab60e8ee', function(data) {
$data = $.parseJSON(JSON.stringify(data, null, 2));
$country = $data['country_code2'];
$region = $data['state_prov'];


if($country == 'AU' || $country == 'IN') {
document.getElementById("box1").style.display = "block";
}
else
{
document.getElementById("box1").style.display = "none";
}
if($region == 'Tasmania' && $region == 'Western Australia'){
  
  document.getElementById("box1").style.display = "block";
  }
});
   